<template>
  <div class="w-full flex flex-col p-1 rounded-xl" style="background-color: #10111A">
    <div class="w-full flex items-center justify-center p-1 mb-1 rounded-md bg-neutral-alpha-50">
      <PauseCircleIcon class="text-neutral-alpha-650" />
      <BaseText type="label" size="sm" class="text-neutral-alpha-650 px-1">
        Inactive
      </BaseText>
    </div>
    <!-- Peak Rank -->
    <div class="w-full flex items-center p-2">
      <PeakIcon class="text-neutral-alpha-650" />
      <BaseText type="body" size="sm" class="pl-2 text-neutral-alpha-650">
        Peak Rank
      </BaseText>
      <BaseText type="label" size="sm" class="ml-auto text-white">
        #{{ rankData.peak_rank }}
      </BaseText>
      <BaseText type="body" size="sm" class="ml-2 pr-1 text-neutral-alpha-700">
        of {{ rankData.peak_total_ads }}
      </BaseText>
    </div>
    <!-- Percentile -->
    <div class="w-full flex items-center p-2 border-b border-neutral-alpha-300">
      <PercentileIcon class="text-neutral-alpha-650" />
      <BaseText type="body" size="sm" class="pl-2 text-neutral-alpha-650">
        Percentile
      </BaseText>
      <BaseText type="label" size="sm" class="ml-auto text-neutral-alpha-700">
        {{ peakPercentileLabel }}
      </BaseText>
    </div>
    <!-- Final Rank -->
    <div class="w-full flex items-center p-2">
      <CheckeredFlagIcon class="text-neutral-alpha-650" />
      <BaseText type="body" size="sm" class="pl-2 text-neutral-alpha-650">
        Final Rank
      </BaseText>
      <BaseText type="label" size="sm" class="ml-auto text-white">
        #{{ rankData.final_rank }}
      </BaseText>
      <BaseText type="body" size="sm" class="ml-2 pr-1 text-neutral-alpha-700">
        of {{ rankData.final_total_ads }}
      </BaseText>
    </div>
    <!-- Percentile -->
    <div class="w-full flex items-center p-2">
      <PercentileIcon class="text-neutral-alpha-650" />
      <BaseText type="body" size="sm" class="pl-2 text-neutral-alpha-650">
        Percentile
      </BaseText>
      <BaseText type="label" size="sm" class="ml-auto text-neutral-alpha-700">
        {{ finalPercentileLabel }}
      </BaseText>
    </div>
  </div>
</template>

<script>
import PauseCircleIcon from '@/components/globals/Icons/PauseCircleIcon.vue'
import PeakIcon from '@/components/globals/Icons/SpyderV2Icons/PeakIcon.vue'
import PercentileIcon from '@/components/globals/Icons/PercentileIcon.vue'
import CheckeredFlagIcon from '@/components/globals/Icons/SpyderV2Icons/CheckeredFlagIcon.vue'

export default {
  name: 'InactiveRanking',
  components: {
    PauseCircleIcon,
    PeakIcon,
    PercentileIcon,
    CheckeredFlagIcon
  },
  props: {
    /*{
      peak_rank: Number,
      final_rank: Number,
      peak_total_ads: Number,
      final_total_ads: Number
    }*/
    rankData: {
      type: Object,
      required: true
    }
  },
  computed: {
    peakPercentileLabel () {
      return getPercentileLabel(this.rankData.peak_rank, this.rankData.peak_total_ads)
    },
    finalPercentileLabel () {
      return getPercentileLabel(this.rankData.final_rank, this.rankData.final_total_ads)
    }
  }
}

const getPercentileLabel = (num, total) => {
  const percentile = Math.ceil((num / total) * 100)
  return isNaN(percentile) ? '--' : `${percentile}%`
}
</script>